import React from 'react';
import { Crown, Medal, Trophy, Coins, User } from '@phosphor-icons/react';

/**
 * Top-tippers leaderboard for a live stream.
 * Renders nothing when there are no tippers.
 */
const TipLeaderboard = ({ leaderboard }) => {
  if (!leaderboard.length) return null;
  const icons = [Crown, Medal, Medal];
  const colors = ['text-amber-400', 'text-slate-300', 'text-orange-400'];

  return (
    <div className="glass-light rounded-xl p-4" data-testid="tip-leaderboard">
      <h3 className="text-sm font-bold text-amber-400 uppercase tracking-wider mb-3 flex items-center gap-2">
        <Trophy weight="fill" className="w-4 h-4" /> Top Tippers
      </h3>
      <div className="space-y-2">
        {leaderboard.map((entry) => {
          const Icon = icons[entry.rank - 1];
          return (
            <div
              key={entry.user_id}
              className={`flex items-center gap-3 p-2.5 rounded-lg ${
                entry.rank === 1 ? 'bg-amber-500/10 border border-amber-500/20' :
                entry.rank === 2 ? 'bg-slate-800/80 border border-slate-700/50' :
                entry.rank === 3 ? 'bg-orange-900/10 border border-orange-800/20' :
                'bg-slate-800/40'
              }`}
              data-testid={`leaderboard-rank-${entry.rank}`}
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                {Icon ? <Icon weight="fill" className={`w-6 h-6 ${colors[entry.rank - 1]}`} /> :
                  <span className="text-sm font-bold text-slate-500">#{entry.rank}</span>}
              </div>
              <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center flex-shrink-0 overflow-hidden">
                {entry.avatar_url ? <img src={entry.avatar_url} alt="" className="w-full h-full object-cover" /> :
                  <User className="w-4 h-4 text-slate-500" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-semibold truncate ${entry.rank === 1 ? 'text-amber-300' : 'text-white'}`}>
                  {entry.display_name}
                </p>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <Coins weight="fill" className={`w-4 h-4 ${entry.rank === 1 ? 'text-amber-400' : 'text-slate-500'}`} />
                <span className={`text-sm font-bold ${entry.rank === 1 ? 'text-amber-400' : 'text-white'}`}>
                  {entry.total_amount}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TipLeaderboard;
